import clsx from 'clsx';

export type TooltipProps = {
    position?: string;
    text: string;
    children?: React.ReactNode;
    classes?: string;
};

export const Tooltip = (props: TooltipProps) => {
    const positionProp = clsx(
        props.position === 'right' &&
            "absolute hidden group-hover:flex -top-2 -right-3 translate-x-full w-max px-2 py-1 bg-gray-700 rounded-lg text-center text-white text-xs before:content-[''] before:absolute before:top-1/2  before:right-[100%] before:-translate-y-1/2 before:border-8 before:border-y-transparent before:border-l-transparent before:border-r-gray-700",
        props.position === 'left' &&
            "absolute hidden group-hover:flex -top-1 -left-3 -translate-x-full w-max px-2 py-1 bg-gray-700 rounded-lg text-center text-white text-xs before:content-[''] before:absolute before:top-1/2  before:left-[99.2%] before:-translate-y-1/2 before:border-8 before:border-y-transparent before:border-r-transparent before:border-l-gray-700",
        props.position !== 'left' &&
            props.position !== 'right' &&
            "absolute hidden group-hover:flex -left-5 -top-2 -translate-y-full w-max px-2 py-1 bg-gray-700 rounded-lg text-center text-white text-xs after:content-[''] after:absolute after:left-1/2 after:top-[100%] after:-translate-x-1/2 after:border-8 after:border-x-transparent after:border-b-transparent after:border-t-gray-700",
    );
    return (
        <div
            data-test-id="tooltip"
            className={clsx('group relative inline-block', props.classes?.includes('m-0') ? '' : 'm-10', props.classes)}
        >
            {props.children}
            <span className={positionProp}>{props.text}</span>
        </div>
    );
};

export default Tooltip;
